<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="名称">
                        <label slot="label" :style="$common.labelStyle('名称')" v-html="'名称'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.opmName" placeholder="名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="部门">
                        <label slot="label" :style="$common.labelStyle('部门')" v-html="'部门'"></label>
                        <el-select v-model="getRequestData.depId" placeholder="请选择" clearable>
                            <el-option v-for="item in departmentList" :key="item.depId" :label="item.depName" :value="item.depId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <label slot="label" :style="$common.labelStyle('状态')" v-html="'状态'"></label>
                        <el-radio-group v-model="getRequestData.opmState" size="mini" @change="searchData">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button :label="1">启用</el-radio-button>
                            <el-radio-button :label="0">停用</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border highlight-current-row @row-click="onRowClick">
                <el-table-column header-align='center' label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmCode" label="编码">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="depName" label="归属部门">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmJob" label="岗位">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmName" label="姓名">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmSex" label="性别"></el-table-column>
                <el-table-column header-align='center' align="center" prop="opmState" label="状态">
                    <template slot-scope="scope">
                        <el-tag size="mini">{{ scope.row.opmState == "0" ? "停用" : "启用" }}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <div id="qx">
                <el-tabs tab-position="left" type="border-card" :stretch="false" v-model="activeName" @tab-click="handleClick" :style="`margin-left:10px;width: 400px;height: ${tableHeight}px;overflow-y: auto;`">
                    <el-tab-pane v-for="(menuOne,menuOneKey) in menuList" :label="menuOne.label" :key="menuOneKey">
                        <keep-alive>
                            <el-tree ref="menuTree" :data="[menuOne]" :show-checkbox="true" :check-strictly="true" :expand-on-click-node='false' node-key="jurId" :props="defaultProps" highlight-current
                                     :default-expanded-keys="[menuOne.jurId]">
                            </el-tree>
                        </keep-alive>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
	  <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
export default {
    data() {
        return {
            buttonList: [],
            tableHeight: 500,
            getRequestData: {
                opmName: "",
                depState: "",
                opgId: "",
                depId: "",
                page: 1,
                rows: 30,
                opmState: "",
            },
            selectedDataIndex: 0,
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            departmentList: [],
            menuList: [],//所有权限
            activeName: '0',
            userJurisdiction: [],
            userJurisdictionDefault: [],
            tabIndex: 0,
        }
    },
    created() {
        this.getAllDepartmentList()
        this.getJurisdictionList()
        this.getDataList()
        this.getButtonList()
    },
    methods: {
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
        handleClick(tab, event) {
            console.log(this.activeName);
            this.tabIndex = Number(tab.index)
            this.$refs.menuTree[this.tabIndex].setCheckedKeys(this.userJurisdiction)
        },
        actionSet(actionType) {
            console.log(actionType);
            switch (actionType.actionType) {
                case 8:
                    if (this.returnData.list.length == 0) {
                        return this.$common.message("暂无数据！")
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        return this.$common.message("请勾选数据！")
                    }
                    this.showPrintPlan()
                    break;
            }
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex]
                let printSource = sessionStorage.getItem('printSource').replace(/\"/g, "")
                this.$refs.printPlan.openDia(info.opmId,printSource, sessionStorage.getItem('printJurId'))
            } else {
                return
            }
        },
        // 获取全部部门
        async getAllDepartmentList() {
            let requestData = await this.$http.getAllDepartmentList();
            if (requestData.status == 200) {
                this.departmentList = requestData.result;
            }
        },
        onRowClick(row, column, event) {
            if (this.returnData.list.indexOf(row) != this.selectedDataIndex) {
                this.selectedDataIndex = this.returnData.list.indexOf(row);
                this.activeName = '0'
                this.tabIndex = 0
                this.getUserJurisdiction()
            }
        },
        searchData() {
            this.returnData.page = 1
            this.getDataList()
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getUserList(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
                if (this.returnData.list.length > 0) {
                    this.getUserJurisdiction()
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        // 获取权限
        async getJurisdictionList() {
            let responseData = await this.$http.getJurisdictionList({ jurType: 0 })  //权限类型权限类型0.erp1.协同
            if (responseData.status == 200) {
                this.menuList = this.handleJurisdiction(responseData.result)
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }

        },
        // 获取用户权限
        async getUserJurisdiction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]

            let responseData = await this.$http.getUserJurisdiction({
                jurType: 0, //	权限类型权限类型0.erp1.协同
                opmId: dataInfo.opmId, //	id列表
            })
            if (responseData && responseData.status && responseData.status == 200) {
                var selectedList = []
                console.log('用户权限', responseData.result)
                responseData.result.forEach(item => {
                    selectedList.push(item.jurId)
                })
                this.userJurisdictionDefault = selectedList
                this.userJurisdiction = selectedList
                this.$nextTick(() => {
                    console.log(this.$refs.menuTree)
                    this.menuList.forEach((item, index) => {
                        this.$refs.menuTree[index].setCheckedKeys([])
                        this.$refs.menuTree[index].setCheckedKeys(this.userJurisdiction)
                    })
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                value['selectedStatus'] = false
                value['disabled'] = true
                this.userJurisdiction.forEach((userValue, userKeys) => {
                    if (value['jurId'] == userValue['jurId']) {
                        value['selectedStatus'] = true
                    }
                })
                if (value['jurParentid'] == id) {
                    value['id'] = value['jurId']
                    value['value'] = value['jurId']
                    value['label'] = value['jurName']
                    var list = this.handleJurisdiction(data, value['jurId'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['jurId'], lev + 1);
                    }
                    son.push(value)
                }
            })
            return son;
        },
    },
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
}
</script>

<style scoped>
.page_content_center {
    display: flex;
    justify-content: space-between;
}
/* ::v-deep .el-tabs--left .el-tabs__nav-wrap.is-left{
    height:300px;
} */
::v-deep #qx .el-tabs__header {
    /* height: auto !important; */
    height: 100% !important;
}
::v-deep .el-tabs--border-card {
    margin-bottom: 0 !important;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #fff;
}
</style>